import { render, staticRenderFns } from "./VerifyUsers.vue?vue&type=template&id=0c0478ac"
import script from "./VerifyUsers.vue?vue&type=script&lang=js"
export * from "./VerifyUsers.vue?vue&type=script&lang=js"
import style0 from "./VerifyUsers.vue?vue&type=style&index=0&id=0c0478ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports